define('cartware_checkout/components/address/selector',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"bootstrap-button"
], function(
	$,
	Component,
	BEM
) {
	function Section(block) {
		var self = this;

		this.block = block;
		this.addressSwitch = this.block.bemGetElements("address-switch");
		this.addressSelect = this.block.bemGetElements("address-select");

		this.block.on("change", "input", function(e) {
			e.preventDefault();

			var input = $(this),
				addressSwitch = self.addressSwitch,
				action = addressSwitch.data("checkout-address-action"),
				type = addressSwitch.data("checkout-address-type"),
				checked = addressSwitch.prop("checked"),
				button = addressSwitch.parent();

			if (this !== addressSwitch.get(0)) button[checked ? "addClass" : "removeClass"]("active");

			self.addressSelect.val(input.val());

			switch (action) {
				case "new":
					self[checked ? "showNewAddressBlock" : "hideNewAddressBlock"](type);
					break;
			}
		});
	}

	Section.prototype = {
		block:			null,
		addressSwitch:	null,
		addressSelect:	null,

		showNewAddressBlock: function(type) {
			var form = this._getNewAddressBlock(type),
				selector = this._getAddressSelector(type);

			form.css("display", "");
			selector.bemAddModifier("disabled");
		},

		hideNewAddressBlock: function(type) {
			var form = this._getNewAddressBlock(type),
				selector = this._getAddressSelector(type);

			form.css("display", "none");
			selector.bemRemoveModifier("disabled");
		},

		_getNewAddressBlock: function(type) {
			return $("#" + type + "-new-address-form");
		},

		_getAddressForm: function(type) {
			return $("#co-" + type + "-form");
		},

		_getAddressSelector: function(type) {
			var className = BEM.buildBlockClassname("customer-address-chooser"),
				parent = this._getAddressForm(type);

			return parent.find("." + className);
		}
	};

	return Component.create({
		$init: function() {
			this.block = BEM.block("checkout-address-selection");

			this.block.each(function() {
				new Section($(this));
			});
		}
	});
});
